import { useEffect, useState } from 'react';
import { useAuthContext } from '../useAuth/useAuthContext';
import LowerApi from '../../modules/lower-api';
import { useLowerApi } from '../useLowerApi/useLowerApi';
import useSessionState from '../useSessionState/useSessionState';
import { SessionStateKeys } from '../../models/session-state-keys';

const verifyUserLoginCode = async (userCode: string, api: LowerApi) => {
  if (!userCode) {
    return 404;
  }
  try {
    const response = await api.authenticate({
      authCode: userCode,
    });

    return response.status;
  } catch (err) {
    let errorMessage = '';

    if (err instanceof Error && err.message) {
      errorMessage = err.message.toString();
    } else if (typeof err === 'string') {
      errorMessage = err.toString();
    }

    return errorMessage.includes('404')
      ? 404
      : 500;
  }
};

const useLoginEndpoint = (
  initialUserCode = '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onComplete = () => {},
) => {
  const { lowerApi } = useLowerApi();

  const { isAuthenticated } = useAuthContext();

  const [userCode, setUserCode] = useSessionState<string>({
    initialState: initialUserCode,
    key: SessionStateKeys.UserCode,
  });

  const [isUserCodeValid, setUserCodeValid] = useState<boolean>(isAuthenticated);

  const [statusCode, setStatusCode] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const status = await verifyUserLoginCode(userCode, lowerApi);

        setUserCodeValid(status === 200);
        setStatusCode(status);
      } catch (err) {
        setUserCodeValid(false);
      } finally {
        onComplete();
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userCode]);

  return {
    isUserCodeValid,
    setUserCode,
    statusCode,
    userCode,
  };
};

export default useLoginEndpoint;
